import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { DataGrid, GridRowModes, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LeadDialog from '../../Components/LeadDialog';
import {Typography, Card, CardActionArea, CardContent, IconButton, Avatar} from '@mui/material';
import { createRequestData, updateRequestData } from '../../Utility/apiHelper';
import moment from 'moment';
import { ACTIVE_STATUS, checkIsActionDisabled, customerIdWidth, DEFAULT_PAGE_SIZE, emailWidth, followupWidth, handleValidateCodevalue, LEAD_DESIRABILITY, LEAD_SOURCE, LEAD_STATUS, LEAD_STATUS_DEAL_CLOSED, leadIdWidth, nameWidth, ownerWidth, phoneWidth, ROWS_PER_PAGE_OPTIONS, statusWidth, whocolumnWidth } from '../../Utility/constant';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import addFollowUpIcon from '../../Assets/images/add_followup.png'; 
import disabledFollowUpIcon from '../../Assets/images/disabled_add_followup.png'; 
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Checkbox, FormControlLabel, FormGroup, Tooltip } from '@mui/material';

import StatusChip from '../../Components/StatusChip';
import ActionableNoteCell from '../../Components/ActionableNoteCell';
import AddActionableNoteDialog from '../../Components/AddActionableNoteDialog';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import { stripHtmlAndWhitespace, valueFormatter } from '../../Utility/textHelper';
import LeadScoreBar from '../../Components/LeadScoreBar';
import CommonBulkUpdate from '../../Components/CommonBulkUpdate';
import BiztantuSearchPageFooter from '../../Components/BiztantuSearchPageFooter';
import './Lead.css';


function CustomToolbar(props) {
  
  const {leadTextfieldData, columnVisibilityModel,setColumnVisibilityModel, columns,quickFilterProps, setIsDialogOpen, selectionModel, handleNotifyLead, isLeadScreen, specificRolePermission  } = props;
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const handleClick = () => {
    setIsDialogOpen({isOpen: true, name: "owner"});
  };
  const handleOpenBulkUpdate = () => {
    setIsDialogOpen({isOpen : true,name: "bulkUpdate"});
  };

  const dispatch = useDispatch()
  const [checkedColumns, setCheckedColumns] = React.useState({});
    const [open , setOpen] = React.useState(false)
  
  const allowedColumnsForCheckbox = React.useMemo(() => {
    return columns.filter((col) => {
      if (col.field === "actions" || col.field === "addfollowup") return false;

      const fieldConfig = leadTextfieldData?.[col.field];

      if (fieldConfig && fieldConfig.visibility === false) {
        return false;
      }

      return true;
    });
  }, [columns, leadTextfieldData]);
  
  useEffect(() => {
    setColumnVisibilityModel(prevModel => {
      if (prevModel && Object.keys(prevModel).length > 0) {
        return prevModel;
      }

      return Object.fromEntries(
        columns.map(col => {
          const fieldConfig = leadTextfieldData?.[col.field];

          if (fieldConfig && fieldConfig.visibility === false) {
            return [col.field, false];
          }

          return [col.field, true];
        })
      );
    });
  }, [columns, leadTextfieldData, setColumnVisibilityModel]);
  
    const handleCheckboxChange = (field) => {
      setCheckedColumns(prev => ({
        ...prev,
        [field]: !prev[field],
      }));
    };
    
    const handleSave=()=>{
      dispatch(requestShowLoader())
       setColumnVisibilityModel(prevModel => ({
        ...prevModel,
        ...checkedColumns
      }))
    setOpen(false)
      dispatch(requestHideLoader())
    }
    const handleOpenFilter = () => {
    setOpen(true);
  
    const updated = {};
    allowedColumnsForCheckbox.forEach((col) => {
      updated[col.field] = columnVisibilityModel?.[col.field] ?? true;
    });
    setCheckedColumns(updated);
  };

  return (
    <GridToolbarContainer className="lead-table-toolbar">
      <Box className="lead-table-toolbar-left">
              <Box>
         <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}>
        <Button onClick={() => handleOpenFilter()} className="lead-table-toolbar-btn-full"> 
          {handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
        </Button>
      </Tooltip>
          </Box>
          <Box>
          </Box>
          </Box>
            <LeadDialog
            open = {open}
            handleClose={()=>setOpen(false)}
            handleSave={handleSave}
            title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
            btnlabel = {handleValidateCodevalue(internationalise,"COMMON_SAVE")}
            >
            <FormGroup>
              <FormControlLabel className="lead-table-select-all-label"
          control={
            <Checkbox
              checked={
                Object.keys(checkedColumns).length > 0 &&
                Object.values(checkedColumns).every(Boolean)
              } // all true
              indeterminate={
                !Object.values(checkedColumns).every(Boolean) &&
                Object.values(checkedColumns).some(Boolean) // partial selection
              }
              onChange={(e) => {
                const checked = e.target.checked;
                // set all columns to same value (true/false)
                const updated = Object.fromEntries(
                  allowedColumnsForCheckbox
                    .filter(col => col.field !== "actions" && col.field !== "addfollowup") // ⛔ exclude these
                    .map(col => [col.field, checked])
                );
                setCheckedColumns(updated);
              }}
            />
          }
          label={handleValidateCodevalue(internationalise,"COMMON_SELECT_ALL")}
        />
            {allowedColumnsForCheckbox
          .map((item) => (
               <FormControlLabel
                key={item.field}
                control={
                  <Checkbox
                    checked={!!checkedColumns[item.field]}
                    onChange={() => handleCheckboxChange(item.field)}
                    
                  />
                }
                label={item.headerName}
              />
            ))}
          </FormGroup>
          </LeadDialog>
        <Box className="lead-table-toolbar-right">
      {/* <GridToolbarExportContainer>
              <GridCsvExportMenuItem
                options={{
                  fileName: `lead_${moment(new Date()).format()}`,
                  delimiter: ';',
                  utf8WithBom: true,
                }}
              />
            </GridToolbarExportContainer> */}
      {isLeadScreen && (<>
       {(specificRolePermission?.isAllLeadManage || specificRolePermission?.isLeadTeamManage) && <Button color="primary" onClick={handleClick} disabled={!(selectionModel.length > 0)} className="lead-table-btn-ml">
          {handleValidateCodevalue(internationalise,'TA_LEAD_RE_ASSIGN')}
      </Button>}
      {(specificRolePermission?.isAllLeadManage || specificRolePermission?.isLeadTeamManage) && <Button color="primary" onClick={handleOpenBulkUpdate} disabled={!(selectionModel.length > 0)} className="lead-table-btn-ml">
          {handleValidateCodevalue(internationalise,'TA_LEAD_BULK_UPDATE')}
      </Button>}
      </>)}
         {/* <Button color="primary" onClick={() => handleNotifyLead(selectionModel)} disabled={!(selectionModel.length > 0)} style={{margin: '0 10px'}}>
           {handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_LEAD')}
        </Button> */}
        <GridToolbarQuickFilter {...quickFilterProps} />
        </Box>
    </GridToolbarContainer>
  );
}

CustomToolbar.propTypes = {
  setIsDialogOpen: PropTypes.func.isRequired,
  selectionModel: PropTypes.array
};

export default function LeadDataGridTable({leadTextfieldData, handleSearch, isLoading, handleNotifyLead, isLeadScreen, specificRolePermission, LeadTableData, handleUpdateLead, pagedLeadData, paginationState, onPageChange, onPageSizeChange}) {
  const [columnVisibilityModel,setColumnVisibilityModel] = React.useState({})  
  const [pagedRows, setPagedRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState({isOpen:false, name: ""});
  const [leadId,setLeadId]=useState(null);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
  const [leadStatus,setLeadStatus]=useState(""); 
  const myTeam = useSelector(state => state?.owner?.Team); 
  const leadDesrirabilityData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_DESIRABILITY)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
  const initialState = {
        dialog  : false,
        checked : true
    }        
      const initialfollowup = {
        followupStatus: "",
        followupNote: "",
        followupDate: "",
        currentDate: "",
    }

    const initialfollowuperror = {
        followupNote: false,
        followupStatus: false,
        followupDate: false
    }
  const [isOpenDialog, setOpenDialog] = useState({
           ...initialState
      });
  const [followUp, setFollowUp] = useState(initialfollowup);
  const [latestFollowUp, setLatestFollowUp] = useState(null);
  const [requiredError, setRequiredError] = useState(initialfollowuperror);
  const leadStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
  const leadSourceData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_SOURCE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
      
  const dispatch = useDispatch();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const currentOwnerId = useSelector(state => state?.owner?.currentuser?.userId);
  const currentOwner = ((specificRolePermission?.isAllLeadManage ? ownerlist : specificRolePermission?.isLeadTeamManage ? myTeam: ownerlist) || []).find(item=> item?.id === currentOwnerId)
  const [selectedowner, setSelectedOwner] = useState("");

  const isMobile = useIsMobile();

  useEffect(()=>{
setSelectedOwner(currentOwner)
  },[currentOwner])

  useEffect(() => {
    if (pagedLeadData?.content && pagedLeadData.content.length > 0) {
      const rows = pagedLeadData.content.map((item) => {
        const countryCode = item?.phoneCountryCode || "";
        const phone = item?.phone || "";

        return {
          ...item,
          phone: countryCode && phone ? `${countryCode}${phone}` : "",
          createdat: item?.createdAt,
          updatedat: item?.updatedAt,
        };
      });

      setPagedRows(rows);
    } else {
      setPagedRows([]);
    }
  }, [pagedLeadData]);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };
  
    const location = useLocation();

  const handleEditLead = (id) => {
  history.push({
    pathname: `${privateRoutesPath.EDIT_LEAD}/${id}`,
    state: {
        from : location.pathname,
        preserveSearch: true,
    }
  });
};
  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = pagedRows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setPagedRows(pagedRows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow, oldRow) => {
    if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
      enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
    } else {
      handleUpdateLead(newRow); 
    }
    const updatedRow = { ...newRow, isNew: false };
    setPagedRows(pagedRows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
    
  };
  const columns = [
    { 
      field: 'id', 
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_LEAD_ID'),
      flex: 1,
      minWidth: leadIdWidth,
      editable: false,
      renderCell: ({id}) => (
      isLeadScreen ?  <span
      onClick={()=>handleEditLead(id)}
      className="lead-table-clickable-id"
    >
      {id}
    </span> :
    <span>
      {id}
    </span>
      )
    },
    { 
      field: 'firstName', 
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_FIRSTNAME'),
      flex: 1,
      editable: true ,
      minWidth: nameWidth,
      
    },
    {field: 'lastName',
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_LASTNAME'),
      flex: 1,
      editable: true,
      minWidth: nameWidth,
       
    },
    {
      field: 'phone',
      headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
      flex: 1,
      editable: false,
      minWidth: phoneWidth,
    },
    {
      field: 'email',
      headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
      flex: 1,
      editable: true,
      minWidth: emailWidth,
    },
    ...(specificRolePermission?.isAimlManage ?
      [
    {
      field: 'leadScore',
      headerName: handleValidateCodevalue(internationalise,'LP_AI_SCORE'),
      flex: 0,
      editable: false,
      width: 150,
      renderCell: (params) => {
        const value = Number(params.value || 0);

        return (
          <LeadScoreBar score={value} />
        )
      }
    }
  ]
  :[]),

    { 
      field: 'customerId', 
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_CUSTOMER_ID'),
      flex: 1,
      editable: false,
      minWidth: customerIdWidth,
       
    },
    {
      field: 'status',
      headerName: handleValidateCodevalue(internationalise,'LEAD_SEARCH_STATUS'),
      flex: 1,
      editable: false,
      minWidth: statusWidth,
      renderCell: (params) => (
        <StatusChip
          isLead = {true}
          systemLookup = {params?.row?.systemLookUpCodeStatus}
          status={params.row.status}
          internationalise={internationalise}
        />)

        // console.log("params?.row",params?.row);
        // if(!params?.row?.status) {
        //   return ""
        // } 
        // return (
        //   <Chip
        //     size='small'
        //     style={{backgroundColor: renderLeadStatus(params?.row?.systemLookUpCodeStatus), width: '100%'}}
        //     variant='outlined'
        //     label={handleValidateCodevalue(internationalise, params?.row?.status )}
        //   />
        // );
      //}
    },
   {
  field: 'leadFollowups',
  headerName: handleValidateCodevalue(internationalise,'LEAD_SEARCH_FU_NOTE'),
  flex: 1,
  editable: false,
  minWidth: followupWidth,  renderCell: (params) => {
    const { value, row } = params;
    
    const isDisabled = checkIsActionDisabled(
      leadStatusData, 
      row?.status, 
      LEAD_STATUS_DEAL_CLOSED, 
      'LEAD_STATUS_CANCELLED', 
      specificRolePermission?.isLeadManage
    );

    const sortedFollowups = value && Array.isArray(value) 
      ? [...value].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      : [];
    
    const latestNote = sortedFollowups.length > 0 ? sortedFollowups[0].note : "";
    const strippedNote = stripHtmlAndWhitespace(latestNote);
    const translatedNote = handleValidateCodevalue(internationalise, strippedNote);
    
    const truncatedText = translatedNote.length > 25
      ? `${translatedNote.substring(0, 25)}...` 
      : translatedNote;

    return (
      <ActionableNoteCell 
        truncatedText={truncatedText}
        isDisabled={isDisabled}
        onClick={() => handleFollowUpClick(row.id, row.status, sortedFollowups[0], isDisabled)}
        tooltipTitle={handleValidateCodevalue(internationalise, 'LEAD_SEARCH_ADD_FU')}
        iconActive={addFollowUpIcon}
        iconDisabled={disabledFollowUpIcon}
        altText="add followup"
      />
    );
  }

}

,
    {field: 'desirability',
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_DESIRABILITY'),
      flex: 1,
      editable: false ,
      minWidth: statusWidth,
      renderCell: (params) => (
        <StatusChip
          isLead = {true}
          chipType="desirability"
          status={params.row.desirability}
          systemLookup = {params?.row?.systemLookupCodeDesirability}
          internationalise={internationalise}
        />
      )
    },
        {field: 'totalValue',
      headerName:  handleValidateCodevalue(internationalise,'LEAD_SEARCH_TOTAL_VALUE'),
      flex: 1,
      editable: false ,
      minWidth: statusWidth,
    },
    { 
      field: 'ownerId', 
      minWidth: ownerWidth,
      headerName: handleValidateCodevalue(internationalise,'LEAD_SEARCH_OWNER'),
      flex: 1,
      editable: false ,
      valueGetter: ({ value }) => value && `${ownerlist?.find(item => item?.id == value)?.firstName} ${ownerlist?.find(item => item?.id == value)?.lastName}`
    },
    {
      field: 'createdat',
      headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
      type: 'date',
      minWidth: whocolumnWidth,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
    {
      field: 'updatedat',
      type: 'date',
      headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
      flex: 1,
      editable: false,
      minWidth: whocolumnWidth,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
  ];

  const handleSave = async () => {

      const rowsData = pagedRows.filter(function(item){
        return selectionModel.indexOf(item.id) !== -1;
      });
      const reqPayload = rowsData.filter((item, index) => item?.owner != selectedowner?.id);

     const payload = reqPayload.map(item => {
        return {
          id: item?.id,
          ownerId: selectedowner?.id
        }
      })
 

  try {
      const response = await updateRequestData(payload, "leads/assign");

      setIsDialogOpen(false);
      setSelectionModel([]);

      if (response?.status === "error") {
          enqueueSnackbar(
              handleValidateCodevalue(
                  internationalise,
                  response?.propererror?.data?.summary || "COMMON_PLEASE_TRY_AGAIN"
              ),
              { variant: "error" }
          );
          return;
}
      enqueueSnackbar(
          `${response?.data?.success} ${handleValidateCodevalue(
              internationalise,
              "LEADS_REASSIGNED_TO"
          )} ${
              ownerlist?.find(item => item?.id === selectedowner?.id)?.firstName
          } ${
              ownerlist?.find(item => item?.id === selectedowner?.id)?.lastName
          }`,
          { variant: "success" }
      );

      setSelectedOwner(currentOwner);
      handleSearch();
  } catch (error) {
      enqueueSnackbar(
          handleValidateCodevalue(
              internationalise,
              error?.propererror?.data?.summary || "COMMON_PLEASE_TRY_AGAIN"
          ),
          { variant: "error" }
      );
  }
  }

  const handleClose = () => {
    setIsDialogOpen({isOpen: false, name: ""});
    setSelectedOwner(currentOwner);
    setFollowUp(initialfollowup); 
    setLatestFollowUp(null);
    

    setRequiredError({
        ...requiredError,
        followupNote: false,
        followupStatus: false,
        followupDate: false
    });
  }

  const handleCancelmultiplelead = async() => {
    const reqPayload = selectionModel.map(item => {
      return {
        status: "Cancel",
        leadId: item
      }
    })

    const url = `${process.env.REACT_APP_BASE_URL}leads/status`;

    const responseData = await updateRequestData(reqPayload, url);
    if(responseData?.status == 200) {
      handleClose();
      setSelectionModel([]);
      enqueueSnackbar(`${reqPayload.length} leads status changed successfully `, { variant: 'success' });
     } else {
        enqueueSnackbar('Please try again.', { variant: 'error' });
    }

  }
  
    const handleSelectOwner = (event, Owner) => {
            setSelectedOwner(Owner)
    }

 
  const handleSaveFollowUp = () => {
          if(followUp?.followupNote) {
              const payload = {
                  "note": followUp.followupNote,
                  "status": leadStatus,
                  "followupDate": followUp.followupDate,
                  "currentDate": moment(new Date()).format('MM/DD/YYYY')
              }
              const isDealClosed = leadStatusData?.find(item=> item?.name == followUp.followupStatus)
              const dealclosed = isDealClosed?.systemLookupCode?.name == LEAD_STATUS_DEAL_CLOSED
              if(dealclosed) {
                  setOpenDialog({
                      ...isOpenDialog,
                      dialog : true
              });
                  setRequiredError({
                      ...requiredError,
                      followupNote: false,
                      followupStatus: false,
                  })
              } 
              
              if(!dealclosed) {
                  handleFollowupmethod(payload, false);
                  setRequiredError({
                      ...requiredError,
                      followupNote: false,
                      followupStatus: false,
                      followupDate: false
                  })
              } else {
                  setRequiredError({
                      ...requiredError,
                      followupNote: true,
                      followupStatus: true,
                  })
              }
  
          } else {    
              setRequiredError({
                  ...requiredError,
                  followupNote: true,
                  followupStatus: true,
                  followupDate: true
              })
          }        
      }
  
  const handleChangeFollowup = (event) => {
        setFollowUp({
            ...followUp,
            [event.target.name]: event.target.value
        })
    }
 const handleFollowupmethod = async(payload, isdealclosed = false) => {
        dispatch(requestShowLoader());
       try {
      const response = await createRequestData(payload,`leads/${leadId}/followup`);

      setFollowUp(initialfollowup);
      // getFollowUpDetails(leadId);

      if (isdealclosed) {
          enqueueSnackbar(
              handleValidateCodevalue(
                  internationalise,
                  "LEAD_DC_SUCCESSFULLY"
              ),
              { variant: "success" }
          );
      } else {
          enqueueSnackbar(
              handleValidateCodevalue(
                  internationalise,
                  "LEAD_FU_ADDED_SUCCESSFULLY"
              ),
              { variant: "success" }
          );

          handleSearch();
          setIsDialogOpen(false);
      }
  } catch (error) {
      enqueueSnackbar(
          handleValidateCodevalue(
              internationalise,
              "COMMON_PLEASE_TRY_AGAIN"
          ),
          { variant: "error" }
      );
  } finally {
      dispatch(requestHideLoader());
  }
    }

   const handleFollowUpClick=(leadId,status, latestData, isReadOnly = false)=>{
    setLeadId(leadId);
    setLeadStatus(status);
    setLatestFollowUp(latestData || null);
    setIsDialogOpen({isOpen:true,name:"followup", isReadOnly})
  }
  const renderValuesOnCard = [
  { field: "status", useLabel: true, left: true,useChip : true,chipType : "status", systemLookupField: "systemLookUpCodeStatus" },
  { field: "desirability", useLabel: true, right: true,useChip : true,chipType:"desirability", systemLookupField: "systemLookupCodeDesirability" },
  {
    field: "fullName",
    left : true,
    combineFields: ["firstName", "lastName",],
    },
    { field: "totalValue" ,right : true,type : "currency"},
];
  
const leftItems = renderValuesOnCard?.filter(item => item?.left);
const rightItems = renderValuesOnCard?.filter(item => item?.right);
const fullWidthItems = renderValuesOnCard?.filter(
  item => !item?.left && !item?.right
);
const userMap = React.useMemo(() => {
  const map = {};
  ownerlist?.forEach((user) => {
    map[user.id] = user;
  });
  return map;
}, [ownerlist]);

const getInitials = (id) => {
  const user = userMap[id];
  if (!user) return "";

  return `${user?.firstName?.[0] || ""} ${
    user?.lastName?.[0] || ""
  }`;
};
const bulkUpdateStatusData = leadStatusData?.filter(item=> item?.systemLookupCode?.name !== "LEAD_STATUS_DEAL_CLOSED")

const bulkUpdateFields = [
  {name : "desirability", label : "LEAD_EDIT_DESIRABILITY", options : leadDesrirabilityData},
  {name : "status", label :  "LEAD_EDIT_STATUS"    ,  options : bulkUpdateStatusData},
  {name : "source", label :   "LEAD_EDIT_SOURCE"   , options : leadSourceData},
]
const renderItem = (card, item, fullValue, displayValue, align = "left") => (
  <Tooltip key={item.field} title={fullValue || ""}>
    {item?.useAvatar ? (
      <Box display="flex" justifyContent={align === "right" ? "flex-end" : "flex-start"}>
        <IconButton className="lead-card-icon-button">
          <Avatar className="lead-card-avatar">
            {getInitials(displayValue)}
          </Avatar>
        </IconButton>
      </Box>
    )
    :
    item?.useChip ? (
      <StatusChip
        isLead={true}
        chipType={item.chipType}
        systemLookup={card?.[item?.systemLookupField] || card?.systemLookUpCodeStatus}
        status={card[item.field]}
        internationalise={internationalise}
      />
    ) : (
      <Typography
        className="lead-card-item-text"
        style={{ textAlign: align === "right" ? "right" : "left" }}
      >
        {displayValue}
      </Typography>
    )}
  </Tooltip>
);

  return (
    <Box className="lead-table-container">
    {isMobile ?
    <Box className="lead-mobile-card-wrapper">
      <Box className="pt-10 lead-mobile-card-grid">
        {
            pagedRows?.length === 0 
            ?
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gridColumn="1 / -1"
              height="200px"
            >
            <Typography variant="body1">
              {handleValidateCodevalue(internationalise,"COMMON_NO_DATA_FOUND")}
            </Typography>
            </Box>
            :
        pagedRows.map((card) => {
          const owner = ownerlist?.find(item=> item?.id === card?.ownerId)
          const ownerInitials = owner
          ? `${owner?.firstName?.charAt(0) || ""}${owner?.lastName?.charAt(0) || ""}`
          : "";
        return (
          <Card    
            key={card.id}
            className="lead-mobile-card"
          >
            <CardActionArea
            onClick={()=>handleEditLead(card.id)}
            className="lead-card-action-area"
            >
              <CardContent>
        <Box display="flex" justifyContent="space-between" width="100%" gap = {"8px"}>
          <Box display="flex" justifyContent="flex-start" alignItems={"center"} gap= "15px" width="48%" >
                <Typography className="lead-card-id-title">
                  {card.id}
      </Typography>
      {card?.leadScore !== undefined && card?.leadScore !== null && (
        <LeadScoreBar score={card?.leadScore} />
      )}
          </Box>
          {card?.ownerId &&
          <Box display="flex" justifyContent="flex-end">
                <IconButton
                  size="small"
                  className="lead-card-icon-button"
                >
                  <Avatar className="lead-card-owner-avatar">
                    {ownerInitials}
                  </Avatar>
                </IconButton>
          </Box>
          }
        </Box>
<Box display="flex" justifyContent="space-between" width="100%">
  
  {/* LEFT */}
  <Box display="flex" flexDirection="column" width="48%">
    {leftItems?.map((item) => {
      const { displayValue, fullValue } = valueFormatter(card, item, internationalise)|| {};
          return renderItem(card, item, fullValue, displayValue, "left");  
    })}
  </Box>

  {/* RIGHT */}
  <Box display="flex" flexDirection="column" alignItems="flex-end"width="48%">
    {rightItems?.map((item) => {
      const { displayValue, fullValue } = valueFormatter(card, item, internationalise)|| {};
      return renderItem(card, item, fullValue, displayValue, "right");  
    }
    )}
  </Box>
</Box>

{/* 🔹 Full Width Rows */}
{fullWidthItems.map((item) => {
  const { displayValue, fullValue } = valueFormatter(
    card,
    item,
    internationalise
  );

  return (
      <Box display="flex"paddingTop = {"10px"} justifyContent={"space-between"} width="100%" gap = {"8px"}>
    <Tooltip key={item.field} title={fullValue || ""}>
      {item?.useChip ? (
                <StatusChip
                          isLead = {true}
                          systemLookup = {card?.systemLookUpCodeStatus}
                          status={card?.status}
                          internationalise={internationalise}
                        />
                )
                :
              (
              <Typography
                className="lead-card-full-width-text"
                style={{ textAlign: item?.useLabel ? "right" : "left" }}
              >
                {displayValue}
              </Typography>
              )}
      
    </Tooltip>
    </Box>
  );
})}
              </CardContent>
            </CardActionArea>
          </Card>
        )
      })
      }
      </Box>
      <BiztantuSearchPageFooter
        paginationState={paginationState}
        pagedData={pagedLeadData}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
  />
  </Box>
    :
      <DataGrid
      disableColumnMenu
      rowHeight={45}
        rows={pagedRows}
        rowCount={pagedLeadData?.totalElements ?? 0}
        pagination
        paginationMode="server"
        page={paginationState?.page ?? 0}
        pageSize={paginationState?.size ?? DEFAULT_PAGE_SIZE}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        className='biztantu-datagrid lead-data-grid'
        columns={columns}
        editMode="row"

        columnVisibilityModel = {columnVisibilityModel}
        checkboxSelection = {true}
        onSelectionModelChange={(newSelectionModel) => {
          setSelectionModel(newSelectionModel);
        }}
        selectionModel={selectionModel}
        rowModesModel={rowModesModel}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableSelectionOnClick
        componentsProps={{
          toolbar: {
            showQuickFilter: pagedRows.length > 0 ? true: false,
            quickFilterProps: { debounceMs: 500, placeholder: handleValidateCodevalue(internationalise,'TA_SEARCH_IN_TABLE') },
            setIsDialogOpen, selectionModel, isLeadScreen,
            handleNotifyLead,specificRolePermission,columns,columnVisibilityModel,setColumnVisibilityModel,leadTextfieldData
          },
        }}
        processRowUpdate={processRowUpdate}
        components={{
          Toolbar: (specificRolePermission?.isLeadManage ) ? CustomToolbar : null,
        }}
        experimentalFeatures={{ newEditingApi: true }}
      />
  }
      {
                (isDialogOpen?.isOpen && isDialogOpen?.name == "owner") && (
                    <LeadDialog 
                        open = {isDialogOpen?.isOpen}
                        handleClose = {handleClose}
                        title= {handleValidateCodevalue(internationalise,"LEAD_REASSIGN_TITLE")}
                        size="sm"
                        selectedowner={selectedowner}
                        btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                        handleSave={handleSave}
                    >
                    <AutoCompleteComponent
                      isOwner = {true}
                      optionSet = {(specificRolePermission?.isAllLeadManage ? ownerlist : specificRolePermission?.isLeadTeamManage ? myTeam: ownerlist) || []}
                      value={selectedowner|| null}
                      name = "managerId"
                      placeholder={handleValidateCodevalue(internationalise,"LEAD_REASSIGN_SELECT_OWNER")}
                      disabled = {!(specificRolePermission?.isAllLeadManage || specificRolePermission.isLeadTeamManage)}
                      label={handleValidateCodevalue(internationalise,'LEAD_SEARCH_OWNER')}
                      onChange={(event, Owner) => handleSelectOwner(event, Owner)}
                      />
                        
                    </LeadDialog>
                )
            }

            {(isDialogOpen?.isOpen && isDialogOpen?.name == "cancelLead") && (
                    <LeadDialog 
                        open = {isDialogOpen?.isOpen}
                        handleClose = {handleClose}
                        title= "Cancel Leads"
                        selectedowner={true}
                        size="sm"
                        btnlabel={handleValidateCodevalue(internationalise,'LEAD_YES')}
                        handleSave={handleCancelmultiplelead}
                        alternateBtnLabel="No"
                    >
                      <Typography gutterBottom>
                      {handleValidateCodevalue(internationalise,'LEAD_CANCEL_CONFIRMATION')}
                      </Typography>
                        
                    </LeadDialog>
                )
            }    
            {(isDialogOpen?.isOpen && isDialogOpen?.name === "bulkUpdate") && (
                    <CommonBulkUpdate 
                        open = {isDialogOpen?.isOpen}
                        handleClose = {handleClose}
                        title= {handleValidateCodevalue(internationalise,"LEAD_BULK_UPDATE_TITLE")}
                        selectedowner={true}
                        dataGridData={LeadTableData}
                        selectionModel={selectionModel}
                        size = "md"
                        fieldsData={bulkUpdateFields}
                        handleSearch={handleSearch}
                        enqueueSnackbar={enqueueSnackbar}
                        internationalise={internationalise}
                    />
                )
            }
           {
    (isDialogOpen?.isOpen && isDialogOpen?.name == "followup") && (
        <AddActionableNoteDialog
            open={isDialogOpen?.isOpen}
            handleClose={handleClose}
            title={handleValidateCodevalue(internationalise, "LEAD_SEARCH_ADD_FU")}
            btnLabel={handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
            handleSave={handleSaveFollowUp}
            latestRecord={latestFollowUp ? {
                ...latestFollowUp,
                note: handleValidateCodevalue(internationalise, latestFollowUp.note),
                date: latestFollowUp.nextdate || latestFollowUp.followupDate
            } : null}
            latestRecordTitle={handleValidateCodevalue(internationalise, "LEAD_SEARCH_FU_NOTE") || "Latest Follow-up"}
            latestNoteLabel={handleValidateCodevalue(internationalise, "LEAD_EDIT_FU_NOTE")}
            latestDateLabel={handleValidateCodevalue(internationalise, "LEAD_EDIT_NEXT_FU_DATE")}
            newRecordTitle={handleValidateCodevalue(internationalise, "LEAD_WANT_TO_ADD_NEW_NOTE") || "Wants to add new note"}
            newNoteLabel={handleValidateCodevalue(internationalise, "LEAD_EDIT_FU_NOTE")}
            newNoteName="followupNote"
            newNoteValue={followUp.followupNote}
            newDateLabel={handleValidateCodevalue(internationalise, "LEAD_EDIT_NEXT_FU_DATE")}
            newDateName="followupDate"
            newDateValue={followUp.followupDate}
            handleOnChange={handleChangeFollowup}
            noteError={followUp?.followupNote ? false : requiredError?.followupNote}
            readOnly={isDialogOpen?.isReadOnly}
        />
    )
}

    </Box>
  );
}
